"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

var _vue = require("vue");

var _hoisted_1 = {
  id: "app",
  class: "col-12"
};
var _hoisted_2 = {
  class: "row"
};

var _hoisted_3 = /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "col-12 col-md-9"
}, [/*#__PURE__*/(0, _vue.createTextVNode)(" Below are client-side buttons demo, go here to see "), /*#__PURE__*/(0, _vue.createElementVNode)("a", {
  href: "https://laratt.niiknow.org/home/contacts",
  target: "_blank"
}, " server-side buttons demo ")], -1
/* HOISTED */
);

var _hoisted_4 = {
  class: "col-12 col-md-3"
};
var _hoisted_5 = {
  class: "input-group"
};

var _hoisted_6 = /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "input-group-append"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("button", {
  type: "submit",
  class: "btn btn-outline-secondary"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("i", {
  class: "mdi mdi-magnify"
}), /*#__PURE__*/(0, _vue.createTextVNode)(" Go ")])], -1
/* HOISTED */
);

var _hoisted_7 = /*#__PURE__*/(0, _vue.createElementVNode)("b", null, "Show Details", -1
/* HOISTED */
);

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_vdtnet_table = (0, _vue.resolveComponent)("vdtnet-table");

  return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [(0, _vue.createElementVNode)("div", _hoisted_2, [_hoisted_3, (0, _vue.createElementVNode)("div", _hoisted_4, [(0, _vue.createElementVNode)("form", {
    class: "form-inline d-flex mx-1 justify-content-end",
    onSubmit: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(function () {
      return _ctx.doSearch && _ctx.doSearch.apply(_ctx, arguments);
    }, ["stop", "prevent"]))
  }, [(0, _vue.createElementVNode)("div", _hoisted_5, [(0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.quickSearch = $event;
    }),
    type: "search",
    placeholder: "Quick search",
    class: "form-control"
  }, null, 512
  /* NEED_PATCH */
  ), [[_vue.vModelText, _ctx.quickSearch]]), _hoisted_6])], 32
  /* HYDRATE_EVENTS */
  )])]), (0, _vue.createCommentVNode)(" Using the VdtnetTable component "), (0, _vue.createVNode)(_component_vdtnet_table, {
    id: "example",
    ref: "table",
    fields: _ctx.fields,
    opts: _ctx.options,
    "select-checkbox": 1,
    details: _ctx.details,
    onEdit: _ctx.doAlertEdit,
    onDelete: _ctx.doAlertDelete,
    onReloaded: _ctx.doAfterReload,
    onTableCreating: _ctx.doCreating,
    onTableCreated: _ctx.doCreated
  }, {
    HEAD__details_control: (0, _vue.withCtx)(function () {
      return [_hoisted_7];
    }),
    address2: (0, _vue.withCtx)(function (ctx) {
      return [(0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(ctx.data.city) + ", " + (0, _vue.toDisplayString)(ctx.comp.formatCode(ctx.data.zipcode)), 1
      /* TEXT */
      )];
    }),
    _details: (0, _vue.withCtx)(function (ctx) {
      return [(0, _vue.createElementVNode)("strong", null, "I'm a child for " + (0, _vue.toDisplayString)(ctx.data.id) + " yall", 1
      /* TEXT */
      )];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["fields", "opts", "details", "onEdit", "onDelete", "onReloaded", "onTableCreating", "onTableCreated"])]);
}